import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

const Admin = () => {
    const user = useSelector((state) => state.auth.user);
    return(
        <div>
            <div className='admin-section'>
                <div className='admin-title' style={{textTransform: "capitalize"}}>
                    {user.name} Dashboard
                </div>
            </div>
        </div>
    )
}

export default Admin;